import { environmentService } from '@/utils/services';
import { compressToUTF16 as compress, decompressFromUTF16 as decompress }  from 'lz-string';
const axios = require('axios');

export const userService = {
  authHeader,
  getRol,
  getRedirect,
  getCrud,
  getClients,
  login,
  logout,
  getAll,
  getUserClient,
  getActiveUser,
};

let apiUrl = environmentService.apiUrlAuth;
let apiUrlUser = environmentService.apiUrlUser;

function login(email, password) {
  return axios.post(`${apiUrl}/login`, {email, password})
    .then(response => {
      if (response.data.status === 200) {
        return response.data;
      }
      logout();
      const error = response.data.errors[0];
      return Promise.reject(error);
    })
    .catch();
  return true;
}

function authHeader() {
  // return authorization header with jwt token
  let user = null;
  if (localStorage.getItem('user')) {
    user = JSON.parse(decompress(localStorage.getItem('user')));
  }

  if (user && user.access_token) {
    return { 'Authorization': 'Bearer ' + user.access_token };
  } else {
    return {};
  }
}

function getActiveUser () {
  let user = null;
  if (localStorage.getItem('user')) {
    user = JSON.parse(decompress(localStorage.getItem('user')));
  }
  if (user && user.access_token) {
    return user;
  } else {
    return {};
  }
}

function getUserClient(auth) {
  const headers = {'Authorization': `Bearer ${auth.data}`};
  const url = `${apiUrl}/validate`;
  return axios.post(url, {next: "auth/validate"}, {headers: headers})
    .then(response => {
      const user = response.data.data;
      const userLogged = {
        id: user.id,
        status: user.status,
        client_id: user.client_id || null,
        name: user.name,
        email: user.email,
        role: user.role,
        access: user.role.access,
        clients: user.client,
        access_token: auth.data,
        first_name: user.first_name,
        last_name: user.last_name,
      };
      //set state
      //this.$store.dispatch({type: 'setRole',role: userLogged.role})
      localStorage.setItem('allowedModules', compress(JSON.stringify(userLogged.role.access)));
      localStorage.setItem('user', compress(JSON.stringify(userLogged)));
      localStorage.setItem('userPublic', (JSON.stringify(userLogged)));
      localStorage.setItem('access_token', compress(JSON.stringify(auth.data)));
      document.cookie = `access_token=${auth.data}`;
      return user;
    });
}

function getCrud(currentModule, permission){
  const user = JSON.parse(decompress(localStorage.getItem('user')));
  const module = currentModule.toLowerCase();
  if(user.access[currentModule]){
    return user.access[currentModule].some(function(el) {
      return el.permission === module+'.'+permission;
    });
  }else{
    return false;
  }
}

async function getRol(){
  var user = JSON.parse(decompress(localStorage.getItem(`user`)));
  return user.role.name;
}

async function getRedirect(){
  var user = JSON.parse(decompress(localStorage.getItem(`user`)));

  if(user.role.name == "Hotel"){
    let route = {
      'text':'Go to your Hotel Inventory',
      'router': '/inventory'
    };
    return route;
  }
  let route = {
    'text':'Search the best room',
    'router': '/availability'
  };
  return route;
}

async function getClients(){
  let headers = {headers: userService.authHeader()};
  return await axios.get(`${apiUrlUser}/clients?next=clients`, headers)
    .then(response => {

      if(response.data.status === 401){
        userService.logout();
      }
      //localStorage.setItem(`categories`, (JSON.stringify(response.data.data)))
      return response.data;
    }).catch(handleErrorResponse);
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem('user');
  localStorage.removeItem('access_token');
  location.reload();

  return true;
}

async function getAll() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
  let handleResponse = await fetch(`${config.apiUrl}/users`, requestOptions);
  return handleResponse(handleResponse);
}

function handleErrorResponse (error) {
  return {
    'status':401,
    'title':'Internal Error',
    'detail':'Internal error, check response log.'
  };
}



// WEBPACK FOOTER //
// ./src/utils/services/auth/user.service.js